"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * call the target func after wait, if call the debounce function before call the target func
 * cancel cancel old execution and add new one.
 *
 * @param func the function to call after wait
 * @param wait the mill seconds to wait
 */

function debounce(func, wait) {
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(function () {
      func.apply(func, args);
      timeoutId = null;
    }, wait);
  };
}

exports.debounce = debounce;